// Kırılım boyut sözlüğü önbelleği (spec §19 B2/B3) — Zustand, ince ve ayrı (kpi-store.ts 600 satır
// sınırına yakın). Yalnız özel boyut listesi tutulur (hazır boyutlar shared'dan); 60 sn bayatlık,
// grup kaydı ya da özel boyut yazımından sonra `invalidate` (sonraki açılış taze listeyi çeker).
// Yükleme hatası pencereyi bozmaz: liste olduğu gibi kalır (yalnız hazır boyutlar görünür).

import { create } from "zustand";
import type { KpiBreakdownCustomDimension } from "@mahir/shared";
import { listKpiBreakdownDimensions } from "../api/kpi";

export const DIMENSIONS_STALE_MS = 60_000;

interface KpiBreakdownDimensionsState {
  custom: KpiBreakdownCustomDimension[];
  loadedAt: number | null;
  load: (force?: boolean) => Promise<void>;
  invalidate: () => void;
}

// uçuştaki yükleme sırasında gelen `invalidate` kuşağı ilerletir — o sonuç taze sayılmaz
let inflight: Promise<void> | null = null;
let generation = 0;

export const useKpiBreakdownDimensionsStore = create<KpiBreakdownDimensionsState>((set, get) => ({
  custom: [],
  loadedAt: null,
  load(force = false) {
    if (inflight) return inflight;
    const { loadedAt } = get();
    if (!force && loadedAt !== null && Date.now() - loadedAt < DIMENSIONS_STALE_MS) {
      return Promise.resolve();
    }
    const startGen = generation;
    inflight = (async () => {
      try {
        const r = await listKpiBreakdownDimensions();
        set({ custom: r.custom, loadedAt: startGen === generation ? Date.now() : null });
      } catch {
        set({ loadedAt: null });
      } finally {
        inflight = null;
      }
    })();
    return inflight;
  },
  invalidate() {
    generation += 1;
    set({ loadedAt: null });
  },
}));
